export default __webpack_public_path__ + "static/media/level-3.26eece5c.png";